import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function additionalFeesTranslation(
  key: string,
  hotelAndMarketService: Services['hotel-and-market'],
  intl: Services['intl'],
) {
  const [lowerFee, upperFee] = key.split('_');

  const from = hotelAndMarketService.formatRate(Number(lowerFee), {
    longFormat: false,
  });

  const to = hotelAndMarketService.formatRate(Number(upperFee), {
    longFormat: false,
  });

  return intl.t(tKey('short_term_rental.breakdowns.additional_fees.XX_YY'), {
    from,
    htmlSafe: true,
    to,
  });
}
